import type { DefineComponentOptions } from "../types.ts";

/**
 *
 *
 *
 *
 *
 */
export const createObservedAttributes = (props: DefineComponentOptions["props"]): string[] =>
  Object.entries(props).map(([key, { attribute }]) => (attribute ? attribute : key));
